import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "../styles/menuItemDetails.css";
import { API_BASE_URL, BASE_URL } from "../api/api";

const MenuItemDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState(null);

  // FETCH SINGLE ITEM
  useEffect(() => {
    const fetchItem = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/menu-item/${id}`);

        const data = await response.json();

        setItem(data);

        // AUTO SELECT FIRST VARIANT
        if (data?.variants?.length > 0) {
          setSelectedVariant(data.variants[0]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchItem();
  }, [id]);

  // LOADING
  if (loading) {
    return (
      <div className="details-loader">
        <div className="loader"></div>
        <p>Loading item...</p>
      </div>
    );
  }

  // ITEM NOT FOUND
  if (!item) {
    return (
      <div className="details-error">
        <h2>Item not found 😔</h2>

        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  // PRICE
  const basePrice = Number(item.price) || 0;
  const variantExtra = Number(selectedVariant?.price) || 0;

  const currentPrice = basePrice + variantExtra;
  // ADD TO CART
  const handleAddToCart = () => {
    addToCart(
      {
        ...item,
        selectedVariant,
        finalPrice: currentPrice,
      },
      quantity,
    );

    navigate("/cart");
  };

  return (
    <div className="item-details-page">
      {/* TOP IMAGE */}
      <div className="top-image">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ←
        </button>

        <img
          src={
            item?.image
              ? `${BASE_URL}/${item.image}`
              : "https://cdn-icons-png.flaticon.com/512/5787/5787016.png"
          }
          alt={item.item_name}
          onError={(e) => {
            e.target.src =
              "https://cdn-icons-png.flaticon.com/512/5787/5787016.png";
          }}
        />
      </div>

      {/* DETAILS */}
      <div className="details-card">
        <div className="title-row">
          <div>
            <h1>{item.item_name}</h1>

            <p className="desc">{item.description || "Delicious food item"}</p>
          </div>

          <div className="price">₹{currentPrice}</div>
        </div>

        {/* VARIANTS */}
        {item?.variants?.length > 0 && (
          <div className="variant-section">
            <h3>Choose Variant</h3>

            <div className="variant-list">
              {item.variants.map((variant) => (
                <button
                  key={variant.id}
                  className={`variant-btn ${
                    selectedVariant?.id === variant.id ? "active" : ""
                  }`}
                  onClick={() => setSelectedVariant(variant)}>
                  {variant.name}{" "}
                  {variant.price > 0 ? `( +₹${variant.price} )` : "(Included)"}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* QUANTITY */}
        <div className="quantity-section">
          <h3>Quantity</h3>

          <div className="quantity-box">
            <button
              onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}>
              -
            </button>

            <span>{quantity}</span>

            <button onClick={() => setQuantity((prev) => prev + 1)}>+</button>
          </div>
        </div>

        {/* TOTAL */}
        <div className="bottom-bar">
          <div>
            <p>Total</p>

            <h2>₹{currentPrice * quantity}</h2>
          </div>

          <button onClick={handleAddToCart}>Add To Cart</button>
        </div>
      </div>
    </div>
  );
};

export default MenuItemDetails;
